module.exports = __webpack_public_path__ + "img/ico-ygl.cff9fbf1.png";